import React, { ReactElement } from 'react';

export default function Divider(): ReactElement {
  return <div style={{ borderBottom: '1px solid #eee' }} />;
}
